import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from '../hooks/useSession';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { session, isLoaded } = useSession();
  const location = useLocation();

  if (!isLoaded) {
    // Auth-check flash. Rather than a "Loading…" text bar, render a
    // calm pulsing dot centered on the page — short-lived (typically
    // <100ms), so anything more would itself be visual noise.
    return (
      <div
        className="min-h-screen bg-cream flex items-center justify-center"
        role="status"
        aria-live="polite"
        aria-label="Checking sign-in"
      >
        <div className="w-2 h-2 rounded-full bg-charcoal/20 animate-pulse" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
